/**
 * AppLayout - Área cliente (dark, sidebar + topbar + bottom nav mobile)
 */
import { Outlet } from "react-router-dom";
import AppSidebar from "@/components/app/AppSidebar";
import AppTopbar from "@/components/app/AppTopbar";
import AppBottomNav from "@/components/app/AppBottomNav";
import ChatWidget from "@/components/app/ChatWidget";
import { useEffect } from "react";

export default function AppLayout() {
    useEffect(() => {
        document.documentElement.classList.add("dark");
        return () => {
            document.documentElement.classList.remove("dark");
        };
    }, []);

    return (
        <div
            className="min-h-dvh bg-background text-foreground bg-noise relative"
            data-testid="app-layout"
        >
            <div className="flex">
                <AppSidebar />
                <div className="flex-1 min-w-0 flex flex-col">
                    <AppTopbar />
                    <main className="flex-1 px-4 sm:px-6 lg:px-8 py-5 sm:py-6 max-w-[1400px] w-full mx-auto pb-24 lg:pb-8">
                        <Outlet />
                    </main>
                </div>
            </div>
            <AppBottomNav />
            <ChatWidget />
        </div>
    );
}
